import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

export function initSentry(Vue, router) {
  const dsn =
    process.env.VUE_APP_SENTRY_DSN ||
    'https://588a2f9eb00d7837acab30eef3a0911e@o4508419443064832.ingest.us.sentry.io/4510377864069120';
  if (!dsn) return;

  try {
    // Vue 2.6.x - @sentry/vue 7.x 사용
    Sentry.init({
      Vue,
      dsn,
      release: process.env.VUE_APP_RELEASE_NAME || 'ceo@dev',
      environment: process.env.VUE_APP_ENVIRONMENT || process.env.NODE_ENV || 'development',
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.vueRouterInstrumentation(router),
          traceFetch: true,
          traceXHR: true,
        }),
      ],
      tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
      sendDefaultPii: true,
      debug: false, // 개발 환경에서도 Sentry 로그 최소화
      beforeSend(event) {
        // 개발 환경에서만 간단한 로그 출력
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.log('[Sentry]', event.message || event.exception?.values?.[0]?.type);
        }
        return event;
      },
    });

    if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
      window.__SENTRY__ = Sentry;
      window.Sentry = Sentry;
      // 강제 테스트 이벤트
      console.log('[Sentry] 초기화 완료, 테스트 메시지 전송 중...');
      Sentry.captureMessage('Sentry init-dev-ping from CEO site');
    }
  } catch (e) {
    console.error('[Sentry] 초기화 실패:', e);
  }
}
